import React from 'react';
import Routes from './routes';
import { Router } from 'react-router-dom'; 
import UserProvider from './context';
import { history } from './history';

function App() {
  

  const appStyles = {        
    minHeight: '100vh', // Garante que o conteúdo se estenda até o fundo da página
  };

  return (
    <UserProvider>
      <div style={appStyles}>
        <Router history={history}>
          <Routes />          
        </Router>
      </div>
    </UserProvider>
  );
}

export default App;
